<template>
  <div class="home">
    <div class="head_box">

      <!-- logo&全部 -->
      <!-- <div class="all">
         <div class="left">
           <img src='../assets/logoh5.png'/>
         </div>
        <div class="right" @click="is_search=!is_search,isshowAddress=false,input='',isarrow=!isarrow">全国
           <span><img src='../assets/jiantou1 (1).png'  v-show="!isarrow" />
           <img src='../assets/jiantou1 (2).png' v-show="isarrow" /></span>
         </div>
      </div> -->
      <!-- 搜索 -->
      <div class="head">
        <div class="left">
           <img src='../assets/logoh52.png'/>
         </div>
         <div >
            <el-input placeholder="请输入内容" v-model="input" class="input-with-select" @input="searchByHand" @keyup.enter.native="searchByHand"/>
         </div> 
         <!-- <div @click="searchByHand" style="right: 40px;position: absolute;">
            <i  class="el-icon-search iconfnt"></i>
         </div> -->
         <div class="right" @click="is_search=!is_search,isshowAddress=false,input='',isarrow=!isarrow">{{city_name}}
           <span><img src='../assets/jiantou1 (1).png'  v-show="!isarrow" />
           <img src='../assets/jiantou1 (2).png' v-show="isarrow" /></span>
         </div>
      </div>

      <!-- 地址关键字搜索 -->
      <div class="address_box" v-show='isshowAddress'>
         <div v-for='(item,index) in placeSearchList' :key='index' @click="select_address(item)">
           <img src='../assets/daohang.png' />
           <span class="span1">{{ item.name }}</span>
           <span class="span2">{{ item.cityname }}</span>
         </div>
      </div>

      <!-- 选择城市 -->
      <div class="City_box" v-show='is_search'>
         <div class="warps1" >
            当前区域：{{ city_name }}
         </div>
         <div class="hotCity">
             <h3>热门城市</h3>
             <div class="box">
               <el-row justify="space-between" :gutter="8">
                   <el-col :span="6" v-for='(item,index) in hotCity' :key='index' >
                      <div class="liCol" @click="handel_hotcity(item)">{{item.value}}</div>
                   </el-col>
               </el-row>
             </div>
         </div>

         <div class="div-container">    
  	       <div class="group-content">
	          <div class="group-list-container" ref="groupRef">
	            <div
	              class="group-list"
	              v-for="(i, index) in cityjson"
	              :key="index"
	            >
	              <div class="list-title" ref="titleRef">
	                {{ i.title}}
	              </div>
	              <div class="Cname"
	                :label="item1.name"
	                v-for="(item1, index1) in i.children"
	                :key="index1"
                  @click="handel_hotcity(item1,2)"
	              >
                  {{item1.name}}
                </div>
	            </div>
	          </div>
	          <div class="word-list">
	            <div class="pin"
	              v-for="item in FristPin"
	              :key="item"
	              @click="goIndex(item)"
	            >
	              {{ item }}
	            </div>
	          </div>
           </div>
         </div>
         
      </div>  
    </div> 

    <div v-show='!is_search'>
      <!-- VR菜单分类 -->
      <div class="vrlist" @click="showVuePopup(false)">
         <div class="search_two">
             <el-row justify="space-between" :gutter="20" >
                 <el-col :span='item.col' style="margin-top:13px" v-for='(item,index) in titlelist' :key='index'>
                   <span :style="current_title===item.id?{fontWeight: '500',color: '#2F88FF'}:''" @click="handel_title(item)">
                       {{item.value}}
                   </span> 
                    <img :src="current_title===item.id?require('../assets/jiantou1 (3).png'):require('../assets/jiantou1 (1).png')"  v-show="!isarrow2&item.id===2" />
                    <img :src="current_title===item.id?require('../assets/jiantou1 (4).png'):require('../assets/jiantou1 (2).png')"  v-show="isarrow2&item.id===2" />
                    <img :src="current_title===item.id?require('../assets/jiantou1 (3).png'):require('../assets/jiantou1 (1).png')"  v-show="!isarrow3&item.id===3" />
                    <img :src="current_title===item.id?require('../assets/jiantou1 (4).png'):require('../assets/jiantou1 (2).png')"  v-show="isarrow3&item.id===3" />
                 </el-col>
             </el-row>
         </div>
         <div class="search_three hotCity" v-show='current_title===2&isshowType' >
             <div class="box">
               <el-row justify="space-between" :gutter="8" v-if='typelist.length>1'>
                   <el-col :span="6" v-for='(item,index) in typelist' :key='index' >
                      <div :class="current_type_img===item.id?'liCol_blue':'liCol'" @click="handel_type(item,2)">{{item.name}}</div>
                   </el-col>
               </el-row>
               <el-row style="margin: 0px 0px 10px;" v-else>
                 暂无数据
               </el-row>
             </div>
         </div>
         <div class="search_three hotCity" v-show='current_title===3&isshowType' >
             <div class="box">
               <el-row justify="space-between" :gutter="8" v-if='typelist_video.length>1'>
                   <el-col :span="6" v-for='(item,index) in typelist_video' :key='index' >
                      <div :class="current_type===item.id?'liCol_blue':'liCol'" @click="handel_type(item,3)">{{item.name}}</div>
                   </el-col>
               </el-row>
               <el-row style="margin: 0px 0px 10px;" v-else>
                 暂无数据
               </el-row>
             </div>
         </div>
      </div>
      <!-- 地图 -->
      <div class="map_select" v-show='!is_search' v-loading="loading">
          <Amap :points='points' :longitude='longitude' :latitude='latitude' :zoom='zoom' @placeSearch='placeSearch' ref='amappage'></Amap>
      </div>
      <!-- 推荐 -->
      <div class="xn-container">
         <div class="footer_box">
           <div class="ft_button1" @click="showVuePopup(true,1)">
              <img src='../assets/jingxuan (1).png'/>
              <p>精选推荐</p>
           </div>
           <div class="ft_button2" @click="showVuePopup(true,2)">
              <img src='../assets/new.png'/>
              <p style='margin-top:-9px'>最新推荐</p>
           </div>
         </div>
        
        <div class="vue-popup">
            <div class="mask" v-show="show2" @click="showVuePopup(false)"></div>
            <transition name="slide">
                <div class="popup-content" v-show="show2">
                    <div class="close" v-show="show2" @click="showVuePopup(false)"></div>
                    <div class="button_box">
                      <div :class="showType===1?'button_box1':'button_box2'" @click="handelRecommend(1)">精选推荐</div>
                      <div :class="showType===2?'button_box1':'button_box2'" @click="handelRecommend(2)">最新推荐</div>
                    </div>
                    <el-row class="row_box" v-show='showType===1'>
                      <el-col :span='12' v-for='(item,index) in BoutiqueList' :key='index'>
                        <a :href="item.linkUrl" style="text-decoration:none">
                         <div class="img_box">
                           <img :src='item.coverImage' />
                           <div class="vrimgicon"><img src='../assets/VRimg.png'></div>
                           <div class="wenzi_box">
                             <h2>{{item.viewName}}</h2>
                             <div class="sub">
                               <img src='../assets/daohang.png' style="width:12px;height: 12px;"/>
                               <span>{{item.cityName}}</span>
                             </div>
                             <div class="line"></div>
                             <p>{{item.authorName}}</p>
                           </div>
                         </div>
                        </a>
                      </el-col>
                    </el-row>
                    <el-row class="row_box" v-show='showType===2'>
                      <el-col :span='12' v-for='(item,index) in NewList' :key='index'>
                        <a :href="item.linkUrl" style="text-decoration:none">
                         <div class="img_box">
                           <img :src='item.coverImage' />
                           <div class="vrimgicon"><img src='../assets/VRvideo.png'></div>
                           <div class="wenzi_box">
                             <h2>{{item.viewName}}</h2>
                             <div class="sub">
                             <img src='../assets/daohang.png' style="width:12px;height: 12px;"/>
                             <span>{{item.cityName}}</span>
                             </div>
                             <div class="line"></div>
                             <p>{{item.authorName}}</p>
                            </div>
                         </div>
                        </a>
                      </el-col>
                    </el-row>
                </div>
            </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Amap from "../components/Amap"
import citylist from "../utils/city"
import points  from "../utils/points"
export default {
  name: 'home',
  components:{ Amap },
  data: () => ({
    spreadlist:[],
    select:'1',
    input:'',
    isarrow:false,
    isarrow2:false,
    isarrow3:false,
    isshowType:false, //是否展示分类
    city_name:'全国',
    hotCity:[
        {id:1,value:'全国',longitude:108.55,latitude:34.32},
        {id:2,value:'北京',longitude:116.397755,latitude:39.903179},
        {id:3,value:'上海',longitude:121.473667,latitude:31.230525},
        {id:4,value:'天津',longitude:117.20000,latitude:39.13333},
        {id:5,value:'南京',longitude:118.46,latitude:32.03}, 
        {id:6,value:'杭州',longitude:120.20000,latitude:30.26667},
        {id:7,value:'郑州',longitude:113.65000,latitude:34.76667},
        {id:8,value:'沈阳',longitude:123.38333,latitude:41.80000},
    ],
    typelist:[],//全景图分类
    typelist_video:[],//全景视频分类
    titlelist:[
        {id:1,value:'全部',col:6,top:'10px'},
        {id:2,value:'VR全景',col:9,top:'13px'},
        {id:3,value:'全景视频',col:9,top:'13px'},
    ],
    materialForm: {
        name: "",
        pos: [],
        posName: "",
        miniUrl: ""
    },
    citylist,
    //points:[],
    points,
    current_type:0,
    current_title:1,
    current_type_img:0,
    is_search:false,
    FristPin: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
    cityjson: [],
    alllist:[],
    show: false,
    show2: false,
    showType:1,  //1精品推荐  2最新推荐
    BoutiqueList:[],
    NewList:[],
    longitude:116,
    latitude:39,
    placeSearchList:[],
    isshowAddress:false,
    zoom:3,
    loading:false
  }),
  mounted() {
      this.sortCity()
      this.cityAll()
      this.typeListdata(0)
      this.typeListdata(1)
      this.recommenddata()
      this.newdata()
  },
  methods: {
       
       //回显关键字搜索list
       placeSearch(item){
          this.isshowAddress = true
          this.placeSearchList = item
       },
       //点击选择关键字搜索的具体值
       select_address(item){
          console.log(item,'itemhhhhh' )
          this.isshowAddress = false
          let location = JSON.parse(JSON.stringify(item.location))
          this.longitude = location.lng
          this.latitude = location.lat
          this.zoom = 16
       },
       //根据关键字去地图获取地址列表
       searchByHand() {       
          if(this.input){
             this.is_search = false
             this.$refs.amappage.searchByHand(this.input);
          }
      },

      handel_hotcity(item,type){
        console.log(item,'item')
        this.is_search = false
        this.isarrow = false
        this.zoom = item.value==='全国'?8:11
        this.city_name =type?item.name: item.value
        this.longitude = item.longitude
        this.latitude  = item.latitude
        console.log(this.zoom,'this.zoom')
      },
      
      //1选择精品  2选择最新
      handelRecommend( val ){
           this.showType = val
      },
      //推荐展开收起
      showVuePopup(flag,val) {
          this.show2 = flag
          this.showType = val
      },
      //城市首字母定位
      goIndex(params) {
        const groupRef = this.$refs.groupRef 
        const titleRef = this.$refs.titleRef 
        titleRef.map((item) => {
          if (item.innerText === params) {
            groupRef.scrollTo({
              top: item.offsetTop,
              behavior: 'smooth' // 平滑移动
            })
          }
        })
      },
      
      sortCity(){
        let cityJsons = {};
        var cityJsondata= [];
        //根据首字母键值对给原数据按首字母分类
        let _this = this
        for (let i = 0; i < _this.FristPin.length; i++) {   
            cityJsons[_this.FristPin[i]] = this.citylist.filter(function (value) {
                return value.letter === _this.FristPin[i];
            })
        }
        //整合按照首字母分类
        cityJsons = Object.values(cityJsons);
        for (let j = 0; j <cityJsons.length; j++) { 
          for (let p = 0; p < _this.FristPin.length; p++) {    
            if(p===j){
               cityJsondata.push({title:_this.FristPin[p],children:cityJsons[j]})
            }    
          }  
        }
        _this.cityjson =cityJsondata;
        //console.log(this.cityjson,'this.cityjson')
      },
      handelselect (data) {
        console.log(data, 'data')
      }, 
      //获取全国VR城市分部列表
      cityAll(id){
        //let devurl = 'http://122.115.53.160:8815/city/view/all'
        let devurl = '/api/city/view/all'
        let param ={
          typeId:id,
        }
        //let url = process.env.NODE_ENV==='development'?  devurl:(process.env.VUE_APP_ENV==='test'?'https://vrworld.igame123.com/backend/apiProxy/city/view/all':'https://vrworld.ophyer.com/backend/apiProxy/city/view/all')
        this.$axios.get(devurl,{ params: param }).then((res) =>{
             console.log(res.data.errMsg,'res')  
             if(res.data.errMsg){
                this.$message.error(res.data.errMsg)
             }      
             else{
                this.points = res.data.data
             }      
        })
      },
      
      //通过分类查询地图
      typecity(id,vrType){
        let devurl = '/api/city/view'
        let param ={
          typeId:id,
          pageNum:1,
          pageSize:9999,
          viewType:vrType
        }
        
        //let url = process.env.NODE_ENV==='development'?  devurl:(process.env.VUE_APP_ENV==='test'?'https://vrworld.igame123.com/backend/apiProxy/city/view/all':'https://vrworld.ophyer.com/backend/apiProxy/city/view/all')
        this.$axios.get(devurl,{ params: param }).then((res) =>{     
             if(res.data.errMsg){
                this.$message.error(res.data.errMsg)
             }      
             else{
                this.points = res.data.data.records
                this.longitude = 116,
                this.latitude = 39,
                this.zoom = 5
             }  
        })
      },
      //分类列表
      typeListdata(type){
        let devurl = '/api/city/type/listByViewType?type='+type
        //let url = process.env.NODE_ENV==='development'?  devurl:(process.env.VUE_APP_ENV==='test'?'https://vrworld.igame123.com/backend/apiProxy/city/view/all':'https://vrworld.ophyer.com/backend/apiProxy/city/view/all')
        this.$axios.get(devurl).then((res) =>{
             if(res.data.errMsg){
                this.$message.error(res.data.errMsg)
             } 
             else{
                if(type===0){
                  this.typelist = res.data.data
                  let item = {
                    id: 0,
                    name: "全部"
                  }
                  this.typelist.unshift(item)
                }      
                else{
                  let item = {
                    id: 0,
                    name: "全部"
                  }
                  this.typelist_video = res.data.data
                  this.typelist_video.unshift(item)
                }  
             }
             //console.log(this.typelist,'this.typelist')
        })
      },
      handel_type(item,type){
          console.log(item,'item')
          this.loading = false
          //this.typecity(item.id,item.vrType)
          this.cityAll(item.id)
          this.isshowType = false
          if(type===2){
             this.isarrow2 = false
             this.current_type_img = item.id
          }
          if(type===3){
             this.isarrow3 = false
             this.current_type = item.id
          }
          // else{
          //   this.current_type = ''
          // }
          this.loading = false
          // this.longitude = item.longitude
          // this.latitude  = item.latitude
          // this.zoom = 8
      },
      handel_title(item){
          if(item.id===2){
             this.isarrow2 = !this.isarrow2
             this.isarrow3 = this.isarrow2?false:this.isarrow3
             this.isshowType = this.isarrow2
             //this.typeListdata(0)
          }
          if(item.id===3){
             this.isarrow3 = !this.isarrow3
             this.isarrow2 = this.isarrow3?false:this.isarrow2
             this.isshowType = this.isarrow3
             //this.typeListdata(1)
          }
          if(item.id===1){
            //  this.isarrow2 = false
            //  this.isshowType = false
             this.cityAll()
          }
          this.current_title = item.id  
      },
      //获取推荐数据
      recommenddata(){
        //let devurl = 'http://122.115.53.160:8815/city/view/all'
        let devurl = '/api/city/view/recommend'
        //let url = process.env.NODE_ENV==='development'?  devurl:(process.env.VUE_APP_ENV==='test'?'https://vrworld.igame123.com/backend/apiProxy/city/view/all':'https://vrworld.ophyer.com/backend/apiProxy/city/view/all')
        this.$axios.get(devurl).then((res) =>{ 
          console.log(res.data,res,res.data.data,'testsesfd')
             if(res.data.errMsg){
                this.$message.error(res.data.errMsg)
             }  
             else{
                this.BoutiqueList = res.data.data
             }                
        })
      },
      //获取最新数据
      newdata(){
        //let devurl = 'http://122.115.53.160:8815/city/view/all'
        let devurl = '/api/city/view/new'
        //let url = process.env.NODE_ENV==='development'?  devurl:(process.env.VUE_APP_ENV==='test'?'https://vrworld.igame123.com/backend/apiProxy/city/view/all':'https://vrworld.ophyer.com/backend/apiProxy/city/view/all')
        this.$axios.get(devurl).then((res) =>{ 
             if(res.data.errMsg){
                this.$message.error(res.data.errMsg)
             }  
             else{
                this.NewList = res.data.data
             }                
        })
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
.all{
  display: flex;
  margin: 0 auto 7px;
  width: 100%;
  .left{
    margin-left: 15px;
    img{
      width: 125.42px;
    }
  }
  .right{
    position: absolute;
    right: 15px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606469;
    span{
      vertical-align: top;
      line-height: 16px;
      img{
        width: 10px;
      }
    }
  }
}
.vrlist{
    position: absolute;
    z-index: 999;
    background-color: white;
    width: 100%;
    overflow: hidden;
}
::v-deep .head{
  display: flex;
  margin: 0 auto;
  background: #F4F6F9;
  border-radius: 20px;
  height: 40px;
  width: 94%;
  .left{
    width: 70px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606469;
    line-height: 48px;
    img{
      width: 32px;
    }
  }
  .right{
    position: absolute;
    right: 30px;
    line-height: 40px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606469;
    span{
      // vertical-align: top;
      // line-height: 16px;
      img{
        width: 10px;
      }
    }
  }
  .el-input{
    margin-left: -33px !important;
  }
 .el-input__inner{
    border: 0px solid #DCDFE6 !important;
    border-radius: 0px !important; 
    background-color: #F4F6F9;
    padding: 0 10px;
  }
  .iconfnt{
    font-size: 16px;
    margin-top: 13px;
    margin-left: 20px;
  }
}

.address_box{
    position: absolute;
    z-index: 9999;
    width: 100%;
    text-align: left;
    padding: 10px 15px 0;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 4%);
    border-radius: 5px;
    div{
      padding: 14px 0;
      border-block-end: 1px solid #F0F2F6;
    }
    img{
      width: 12px;
    }
    .span1{
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #303234;
      line-height: 20px;
      margin: 0 10px;
    }
    .span2{
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #989EA6;
      line-height: 17px;
    }
}

.warps1{
    width: 100%;
    height: 40px;
    background: #F4F6F9;
    margin: 0px auto 15px;
    line-height: 40px;
    float: left;
    text-align: left;
    padding-left: 15px;
}
.hotCity{
  h3{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #989EA6;
    margin-left: 15px;
    text-align: left;
  }
  .liCol{
    height: 32px;
    background: #F4F6F9;
    border-radius: 5px;
    margin-bottom: 8px;
    line-height: 32px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #303234;
  }
  .liCol_blue{
    background: linear-gradient(90deg, #5CBDFF 0%, #2F88FF 100%);
    box-shadow: 0px 2px 5px 0px rgba(42, 118, 221, 0.24);
    height: 32px;
    border-radius: 5px;
    margin-bottom: 8px;
    line-height: 32px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #fff;
  }
  .box{
    margin: 0 auto;
    width: 355px;
  }
}
.search_two{
   margin: 0px 0 9px;
   span{
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #606469;
      line-height: 20px;
   }
   img{
     width: 10px;
     vertical-align: top;
     margin-top: 8px;
   }
}
.search_three{
   margin-top: 14px;
   border-block-start: 1px solid #E8E9EC;
   .box{
      margin-top: 16px;
   }
}


.div-container {
     text-align: left;
     margin-left: 15px;
     margin-top: 22px;
    .group-content {
      height: 500px;
      position: relative;
      bottom:20px;
      height: calc(100vh - 260px);
      .group-list-container {
        height: 100%;
        overflow: auto;
        .group-list {
          margin-bottom: 16px;
          .list-title {
             margin:20px 0 1px;
             font-size: 14px;
             font-family: PingFangSC-Regular, PingFang SC;
             font-weight: 400;
             color: #989EA6;
          }
        }
      }

      .word-list {
        position: absolute;
        right: 19px;
        top: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 500px;
        font-size: 12px;
        font-weight: 400;
        color: #3e4451;
        div {
          text-align: center;
          cursor: pointer;
        }
      }

   .Cname{
     font-size: 16px;
     font-family: PingFangSC-Regular, PingFang SC;
     font-weight: 400;
     color: #303234;
     border-bottom: 1px solid #f0f2f6;
     padding-bottom: 18px;
     padding-top: 13px;
   }
   .pin{
     font-size: 12px;
     font-family: PingFangSC-Medium, PingFang SC;
     font-weight: 500;
     color: #303234;
     line-height: 17px;
   }
    }
}

.xn-container {
    //height: 100%;
    .footer_box{
      width: 42px;
      height: 85px;
      position:absolute;
      bottom: 70px;
      right: 12px;
      background: #FFFFFF;
      box-shadow: 0px 0px 7px 0px rgba(0, 92, 193, 0.3);
      border-radius: 5px;
      .ft_button1{
        margin-top: 6px;
      }
      .ft_button2{
        margin-top: -11px;
      }
      img{
        width: 22px;
      }
      p{
         font-size: 16px;
         font-family: PingFangSC-Regular, PingFang SC;
         font-weight: 400;
         color: #303234;
         line-height: 16px;
         margin-top: -6px;
         -webkit-transform: scale(0.5);
         transform: scale(0.5);
        // width: 64px;
        // margin-left: -11px;
         width: 80px;
         margin-left: -18px;
      }
      .row_box{
        margin: 0 auto;
        text-align: center;
      }
    }

}

.vue-popup {
    .close{
       width: 40px;
       height: 4px;
       background: rgba(0, 0, 0, 0.3);
       border-radius: 2px;
       position: absolute;
       top: -12px;
       margin: 0px auto;
       text-align: center;
       left: 45%;
    }
    .popup-content {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        -webkit-transition: all 0.2s ease-in;
        transition: all 0.2s ease-in;
        height: 478px;
        background: linear-gradient(180deg, #FFFFFF 0%, #F4F6F9 100%);
        box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.04);
        border-radius: 20px 20px 0px 0px;
        z-index: 99999;
        // overflow: auto;
        p {
            line-height: 30px;
            text-align: center;
        }
        .button_box{
            display: flex;
            width: 208px;
            height: 42px;
            background: #F4F6F9;
            border-radius: 21px;
            margin: 9px auto 0;
            .button_box1{
               width: 90px;
               height: 32px;
               background: #FFFFFF;
               border-radius: 16px;
               margin: 0 6px;
               line-height: 35px;
               margin-top: 5px;
               color: #2F88FF;
            }
            .button_box2{
               width: 90px;
               height: 32px;
               border-radius: 16px;
               margin: 0 6px;
               line-height: 35px;
               margin-top: 5px;
            }
        }
        .img_box{
            margin: 15px auto 0;
            width: 167px;
            height: 220px;
            background: #FFFFFF;
            border-radius: 5px;
            img{
               width: 167px;
               object-fit:cover;
               height: 125px;
               border-radius: 5px 5px 0 0;
            }
            .vrimgicon{
               position: relative;
               top: -78px;
               img{
                  width: 24px;
                  height: 24px;
               }
            }
            .wenzi_box{
              margin-left: 10px;
              margin-top: -32px;
               .sub{
                   font-size: 12px;
                   font-family: PingFangSC-Regular, PingFang SC;
                   font-weight: 400;
                   color: #989EA6;
                   margin-top: -10px;
                   text-align: left;
                   img{
                      position: absolute;
                      margin-top: 3px;
                   }
                   span{
                     margin-left: 13px;
                   }
               }
               .line{
                 margin-top: 8px;
                 width: 147px;
                 height: 1px;
                 background: #E8E9EC;
                 border-radius: 2px;
               }
               p{
                 font-size: 12px;
                 font-family: PingFangSC-Regular, PingFang SC;
                 font-weight: 400;
                 color: #989EA6;
                 line-height: 12px;
                 text-align: left
               }
               h2{
                 white-space: nowrap;// 文字不换行
                 overflow: hidden;// 超出隐藏
                 text-overflow: ellipsis;
                 width: 142px;
                 font-size: 14px;
                 font-family: PingFangSC-Medium, PingFang SC;
                 font-weight: 500;
                 color: #333333;
                 line-height: 20px;
                 text-align: left;
              }
            } 
        }
        .row_box{
            overflow: auto;
            height: 425px;
            margin: 0 8px;
        }
    }
}
.mask {
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    height: 100%;
    // background-color: rgba(0, 0, 0, 0.4);
    transition: all 0.2s ease-in;
}
 
.slide-enter-active {
    animation-name: slideInUp;
    animation-duration: 0.2s;
    animation-fill-mode: both;
}
.slide-leave-active {
    animation-name: slideOutDown;
    animation-duration: 0.2s;
    animation-fill-mode: both;
}
@keyframes slideInUp {
    0% {
        transform: translate3d(0, 100%, 0);
        visibility: visible;
    }
 
    to {
        transform: translateZ(0);
    }
}
@keyframes slideOutDown {
    0% {
        transform: translateZ(0);
    }
 
    to {
        visibility: hidden;
        transform: translate3d(0, 100%, 0);
    }
}
.delay-leave-active {
    -webkit-animation-delay: 0.2s;
    -moz-animation-delay: 0.2s;
    -o-animation-delay: 0.2s;
    animation-delay: 0.2s;
}


</style>
